<!-- Use this for components where the heading level varies based on the hierarchy level  -->

<template>
  <component :is="headingTag">
    <slot />
  </component>
</template>

<script>
export default {
  props: {
    level: {
      type: Number,
      required: true,
      validator: (value) => value >= 1 && value <= 6,
    },
  },
  computed: {
    headingTag() {
      return `h${this.level}`
    },
  },
}
</script>
